import React, { useState } from 'react';
import { Button } from 'antd';
import { SearchDropdownContent, SearchInput, VerticalCheckboxGroup } from './FilterDropdown.styled';

const SelectFilterDropdown = (columnName, options, setFilters, t, highlight, dropdownWidth, searchEnabled = false) => ({
  // eslint-disable-next-line react/prop-types
  setSelectedKeys, selectedKeys, confirm, clearFilters,
}) => {
  const setFilterValue = (value) => {
    setFilters({ [columnName]: value });
  };

  const handleSearch = () => {
    setFilterValue(selectedKeys);
    if (!highlight) {
      confirm();
    }
  };

  const handleReset = () => {
    setFilterValue(null);
    if (!highlight) {
      clearFilters({ confirm: true });
    }
  };

  const [query, setQuery] = useState('');

  const normalizedQuery = query.trim().toLowerCase();
  const filteredOptions = !normalizedQuery
    ? options
    : options.filter((option) => {
      const searchValue = option.searchValue
        || (typeof option.label === 'string' ? option.label : option.value);
      const searchValues = Array.isArray(searchValue) ? searchValue : [searchValue];
      return searchValues.some((value) => String(value).toLowerCase().includes(normalizedQuery));
    });

  return (
    <SearchDropdownContent style={dropdownWidth ? { width: dropdownWidth } : undefined}>
      {searchEnabled && (
        <SearchInput
          placeholder={`${t('COMMON.SEARCH_BY')} ${t(`PROPERTIES.${columnName}`)}`}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      )}
      <VerticalCheckboxGroup
        options={filteredOptions.map((option) => ({
          label: typeof option.label === 'string' ? t(option.label) : option.label,
          value: option.value,
        }))}
        value={selectedKeys}
        onChange={(e) => setSelectedKeys(e)}
      />
      <div className="ant-table-filter-dropdown-btns">
        <Button
          onClick={() => handleReset(setFilterValue, clearFilters)}
          size="small"
          type="link"
          disabled={!selectedKeys[0]}
        >
          {t('COMMON.RESET')}
        </Button>
        <Button
          type="primary"
          onClick={() => handleSearch(setFilterValue, selectedKeys, confirm)}
          size="small"
        >
          {t('COMMON.OK')}
        </Button>
      </div>
    </SearchDropdownContent>
  );
};

export default SelectFilterDropdown;
